import { Component, Input, OnInit } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { PurifiersDetailsComponent } from '../modals/purifiers-details/purifiers-details.component'

@Component({
	selector: 'app-b2b-product-card',
	templateUrl: './b2b-product-card.component.html',
	styleUrls: ['./b2b-product-card.component.scss'],
})
export class B2bProductCardComponent implements OnInit {
	@Input() item: any = {}
	@Input() lang: string = 'pt'
	@Input() knowBtn: string = 'Ficha Técnica'

	constructor(private modal: NgbModal) {}

	ngOnInit(): void {}

	openModal(item: any) {
		const modalRef = this.modal.open(PurifiersDetailsComponent)
		modalRef.componentInstance.data = item
		modalRef.componentInstance.lang = this.lang
		modalRef.componentInstance.hasB2b = true
	}
}
